import React from 'react';
import { OnboardingDialogBase } from './OnboardingDialogBase';

export interface IBetaAcknowledgeDialogProps {
	onClose: () => void;
	stepText?: string;
}

export const BetaAcknowledgeDialog: React.FC<IBetaAcknowledgeDialogProps> = ({
	onClose,
	stepText,
}) => {
	return (
		<OnboardingDialogBase
			title="Beta testing"
			badgeText="Beta Testing"
			stepText={stepText}
			onAcknowledge={onClose}
		>
			<p>Elyx is currently in its testing phase with selected users only.</p>
			<p>
				Beta testing comes with risks. You could encounter bugs. We will
				address each bug if you let us know through our{' '}
				<a
					href="https://discord.gg/DR2qZupRQW"
					target="_blank"
					rel="noopener noreferrer"
					className="onboarding-link"
				>
					discord server
				</a>
				.
			</p>
		</OnboardingDialogBase>
	);
};

export default BetaAcknowledgeDialog;
